import { RoleType } from "common/models/role/Role";

type ResourceBalanceTranslationKey =
    | "organizationBalance"
    | "programBalance"
    | "partnerBalance"
    | "operationManagerBalance"
    | "customerServiceBalance";

type ResourceBalanceTranslations = {
    [key in RoleType]: ResourceBalanceTranslationKey;
};

export const RESOURCE_BALANCE_TRANSLATIONS: ResourceBalanceTranslations = {
    [RoleType.ORGANIZATION_OWNER]: "organizationBalance",
    [RoleType.PROGRAM_MANAGER]: "programBalance",
    [RoleType.PARTNER]: "partnerBalance",
    [RoleType.OPERATION_MANAGER]: "operationManagerBalance",
    [RoleType.CUSTOMER_SERVICE]: "customerServiceBalance",
};
